import { render } from "./BubbleChart.vue?vue&type=template&id=4fe98368&scoped=true"
import script from "./BubbleChart.vue?vue&type=script&lang=js"
export * from "./BubbleChart.vue?vue&type=script&lang=js"

import "./BubbleChart.vue?vue&type=style&index=0&id=4fe98368&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe98368"]])

export default __exports__